import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Home from '../Home/home'
import Experience from "../Experience/experience"
import styles from './navbar.module.css'
import Paper from '@material-ui/core/Paper';
import Personal_projects from '../Personal-Projects/personalProjects'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box p={3}>
        <Typography>{children}</Typography>
      </Box>
    )}
  </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}


export default function ScrollableTabsButtonAuto() {
  const [value, setValue] = React.useState(0);




  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="container">
    
    <Tabs style={{ background: 'transparent', boxShadow: 'none'}}
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="transparent"
        centered
      >
          <Tab label="Home" {...a11yProps(0)} />
          <Tab label="Work Experience" {...a11yProps(1)} />
          <Tab label="Personal Projects" {...a11yProps(2)} />
        </Tabs>
      
      <TabPanel value={value} index={0}>
        <Home/>
      </TabPanel>
      <TabPanel value={value} index={1}>
       <Experience/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Personal_projects/>
      </TabPanel>
    </div>
  );
}
